/**
 * Tag Link atomic — compact clickable tag (navigate or action).
 */
export { TagLink, type TagLinkProps } from './TagLink';
export { tagLinkVariants, type TagLinkVariantProps } from './tag-link.variants';
